import { observer } from 'mobx-react-lite'
import React, { useCallback, useEffect, useState } from 'react'
import { TouchableOpacity, View, ViewStyle } from 'react-native'

import { ResourceReadModelType } from '@trivie/core'

import { iconPlay } from '../../assets'
import { InViewPort } from '../feed/invp'
import { SvgIcon } from '../svg-icon'

export interface VideoPlayerProps {
  index?: number
  currentViewableIndex?: number
  source: ResourceReadModelType
  thumbnail?: string
  viewed?: any
  isDetail?: boolean
  alreadyPaused?: boolean
  isMobile?: boolean
}

const CONTAINER: ViewStyle = {
  width: '100%',
  alignContent: 'center',
}

/**
 * Video Player component
 */
export const VideoPlayer = observer((props: VideoPlayerProps) => {
  const { source, isMobile } = props
  const [paused, setPaused] = useState(true)

  useEffect(
    useCallback(() => {
      if (props.currentViewableIndex !== props.index) {
        setPaused(false)
      }
    }, []),
    [props.currentViewableIndex],
  )

  return (
    <View style={CONTAINER}>
      {paused ? (
        <View style={{ backgroundColor: 'black', height: isMobile ? 197 : 316, width: '100%' }}>
          <TouchableOpacity
            onPress={() => setPaused(false)}
            style={{
              flex: 1,
              justifyContent: 'center',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <SvgIcon src={iconPlay} size={128} viewBox="0 0 24 24" color="#fff" />
          </TouchableOpacity>
        </View>
      ) : (
        <View
          style={{
            paddingHorizontal: 20,
            backgroundColor: '#fff',
            height: isMobile ? 197 : 316,
            width: '100%',
          }}
        >
          <InViewPort
            //@ts-ignore
            onChange={(isVisible: any) => {
              const el = document.getElementById(source?.title)
              if (el) {
                if (isVisible) {
                  // @ts-ignore
                  el.play()
                } else {
                  // @ts-ignore
                  el.pause()
                }
              }
            }}
          >
            <video
              autoPlay
              style={{ alignSelf: 'center', borderRadius: 20 }}
              id={source?.title}
              height={isMobile ? 197 : 300}
              playsInline
              controls
              muted={true}
              src={source?.file_url}
            />
          </InViewPort>
        </View>
      )}
    </View>
  )
})
